export default "__VITE_ASSET__4ff73599__"